import { graphql, useStaticQuery } from "gatsby"
import { TPost } from "../types"

const allRedAlertNewsPosts = (): TPost[] => {
  const query = useStaticQuery(
    graphql`
      {
        allNewsPost(filter: {categories: {elemMatch: {slug: {eq: "redalert"}}}}) {
          nodes {
            id
            title
            summary
            avatar {
              id
              title
              ... on DatoCmsAsset {
                gatsbyImageData(
                  imgixParams: {crop: "focalpoint", fit: "crop", w: "200", h: "200"}
                )
              }
            }
            slug
            categories {
              title
              slug
              id
            }
            content {
              ... on DatoCmsFormattedText {
                id
                value
              }
            }
          }
        }
      }
    `
  )
  return query.allNewsPost.nodes
}

export default allRedAlertNewsPosts